import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API from '../../../utils/axiosConfig'; // adjust this path
import './MatchProfileListing.css';
import { useNavigate } from 'react-router-dom';
import MainNavbar from '../MainNavbar';
import SubscriptionModal from './SubscriptionModal';
import Chatroom from '../Chating/Chatroom'; // Import the Chatroom component
import { FiUser, FiUserCheck } from "react-icons/fi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { io } from 'socket.io-client';
import { format, isYesterday, formatDistanceToNow } from 'date-fns';
import { isToday, differenceInDays } from 'date-fns';
import { HiOutlineSearch } from "react-icons/hi";
import { FaGem, FaMedal, FaStar, FaCircle } from 'react-icons/fa';
import {
    faMapMarkerAlt,
    faPrayingHands,
    faUsers,
    faBriefcase,
    faEye,
    faTrashAlt,
    faChevronLeft, faTimes,
    faChevronRight,
    faHeart,
} from "@fortawesome/free-solid-svg-icons";
import {
    GiCheckedShield,
    GiMetalBar,
    GiGoldBar,
    GiTrophyCup,
    GiCutDiamond
} from 'react-icons/gi';
import { AiOutlineMessage } from "react-icons/ai";
import { IoMdClose } from 'react-icons/io';
import { GiPartyPopper } from "react-icons/gi";
import { Helmet } from "react-helmet";
import { useContext } from "react";
import AlertContext from "../../../contexts/AlertContext";

const HomeList = ({ profile }) => {
    const [profiles, setProfiles] = useState([]);
    const [currentUser, setCurrentUser] = useState({ userId: '', gender: '', name: '' });
    const [selectedProfiles, setSelectedProfiles] = useState([]);
    const [shortlistedUsers, setShortlistedUsers] = useState([]);
    const [error, setError] = useState(null); // Add this line
    const [isOpen, setIsOpen] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [matchScores, setMatchScores] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [statusFetched, setStatusFetched] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [isOnline, setIsOnline] = useState(false);
    const [lastSeen, setLastSeen] = useState(null);
    const [userStatus, setUserStatus] = useState({});
    const [expandedFilters, setExpandedFilters] = useState({});
    const [searchTerm, setSearchTerm] = useState('');
    const [planInfo, setPlanInfo] = useState([]);
    const [showProfileModal, setShowProfileModal] = useState(false);
    const [selectedReligions, setSelectedReligions] = useState([]);
    const [lastSelectedReligion, setLastSelectedReligion] = useState("");
    const { showAlert } = useContext(AlertContext);
    const navigate = useNavigate();

    const religionContent = {
        Hindu: `Find the perfect Tamil Hindu match from communities like Iyer, Iyengar, Nadar, Mudaliar, Gounder, and Vanniyar. Varankal ensures cultural compatibility with modern convenience.`,
        Christian: `Connect with verified Christian profiles from Catholic, CSI, Pentecostal, and Orthodox backgrounds.  Faith and love come together beautifully here.`,
        Muslim: `Respectful, private, and genuine — our Tamil Muslim Matrimony service helps you find a life partner who values faith and family.
`,
    };


    useEffect(() => {
        const step = localStorage.getItem("profileStep");

        if (step !== "3") {
            setShowProfileModal(true);   // show popup ONLY if not completed
        } else {
            setShowProfileModal(false);  // completed → never show again
        }
    }, []);

    const step = localStorage.getItem("profileStep");

    // Dynamic title based on step
    const stepTitle =
        step === "0"
            ? "Complete Your Basic Registration"
            : step === "1"
                ? "Create Your Profile"
                : step === "2"
                    ? "Set Your Partner Preferences"
                    : "Profile Completed";

    const buttonText =
        step === "0"
            ? "Free Registration"
            : step === "1"
                ? "Create Profile"
                : step === "2"
                    ? "Set Partner Preferences"
                    : "Go to Dashboard";


    const getUniqueOptions = (profiles, key) => {
        const seen = new Map();
        profiles.forEach(profile => {
            const rawValue = profile[key]?.trim();
            if (rawValue) {
                const normalized = rawValue.toLowerCase();
                if (!seen.has(normalized)) {
                    seen.set(normalized, rawValue);
                }
            }
        });
        return Array.from(seen.values()).map(val => ({ label: val, value: val }));
    };

    const locationOptions = getUniqueOptions(profiles.map(p => ({ location: p.location?.district })), 'location');
    const religionOptions = getUniqueOptions(profiles, 'religion');
    const casteOptions = getUniqueOptions(profiles, 'caste');
    const occupationOptions = getUniqueOptions(profiles, 'occupation');

    const filterGroups = [
        { name: 'location', label: 'Location', options: locationOptions },
        { name: 'religion', label: 'Religion', options: religionOptions },
        { name: 'caste', label: 'Caste', options: casteOptions },
        { name: 'occupation', label: 'Occupation', options: occupationOptions }
    ];

    const applyFilters = (profile) => {
        const { location, religion, caste, occupation, shortlistedOnly, ageRange } = filterCriteria;

        const matches = (fieldValue, selectedValues) =>
            !selectedValues.length || selectedValues.includes(fieldValue?.toLowerCase());

        const isShortlisted =
            !shortlistedOnly ||
            shortlistedUsers.some(user => {
                const shortlistedUserId = user.shortlistedUser?._id || user.userId || user._id;
                return shortlistedUserId === profile._id || shortlistedUserId === profile.userId;
            });

        const profileAge = profile.age || 0;

        const searchLower = searchTerm.toLowerCase();
        const nameMatch = profile.name?.toLowerCase().includes(searchLower);
        const idMatch = profile.userId?.toLowerCase().includes(searchLower) || profile._id?.toLowerCase().includes(searchLower);
        const matchesSearch = !searchTerm || nameMatch || idMatch;

        return (
            matches(profile.location?.district?.toLowerCase(), location.map(v => v.toLowerCase())) &&
            matches(profile.religion?.toLowerCase(), religion.map(v => v.toLowerCase())) &&
            matches(profile.caste?.toLowerCase(), caste.map(v => v.toLowerCase())) &&
            matches(profile.occupation?.toLowerCase(), occupation.map(v => v.toLowerCase())) &&
            (currentUser.gender === 'male' ? profile.gender === 'female' : profile.gender === 'male') &&
            profileAge >= ageRange[0] &&
            profileAge <= ageRange[1] &&
            isShortlisted &&
            matchesSearch
        );
    };

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) return;

        axios
            .get('https://back.varankal.com/app/userreports/all-users-view-usage', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                withCredentials: true,
            })
            .then((res) => {
                setPlanInfo(res.data); // res.data is an array of users
            })
            .catch((err) => {
                setError('Unable to fetch all users plan details.');
                console.error(err);
            });
    }, []);

    const handleFilterChange = () => {
        const filtered = profiles.filter(applyFilters);
        setFilterCriteria(filtered);
    };

    const handleReset = () => {
        setFilterCriteria({
            location: [],
            religion: [],
            caste: [],
            occupation: [],
            shortlistedOnly: false,
            ageRange: [18, 40]
        });
    };
    const [filterCriteria, setFilterCriteria] = useState({
        location: [],
        religion: [],
        caste: [],
        occupation: [],
        shortlistedOnly: false,
        ageRange: [18, 40]
    });
    const iconMap = {
        location: faMapMarkerAlt,
        religion: faPrayingHands,
        caste: faUsers,
        occupation: faBriefcase,
    };


    const toggleSelect = (userId) => {
        setSelectedUsers(prev =>
            prev.includes(userId)
                ? prev.filter(id => id !== userId)
                : [...prev, userId]
        );
    };

    const profilesPerPage = 8; // 2 rows * 4 columns
    const totalPages = Math.ceil(profiles.length / profilesPerPage);


    useEffect(() => {
        document.body.classList.add('body-background');

        return () => {
            document.body.classList.remove('body-background');
        };
    }, []);

    useEffect(() => {
        const fetchData = async (userId) => {
            try {
                // 1. Fetch current user
                const currentUserRes = await API.get(`/user/currentregister-details/${userId}`);
                const currentUser = {
                    userId: currentUserRes.data.userId,
                    name: currentUserRes.data.basicDetails.name,
                    gender: currentUserRes.data.basicDetails.gender,
                };
                setCurrentUser(currentUser); // Update state

                // 2. Fetch all register data
                const registerResponse = await axios.get('https://back.varankal.com/user/all-register-details', { withCredentials: true });
                const shortlistRes = await axios.get('https://back.varankal.com/auth/shortlisted/ids', { withCredentials: true });
                const shortlistedIds = shortlistRes.data.shortlistedIds;
                const registerData = registerResponse.data.reduce((acc, profile) => {
                    acc[profile.userId] = {
                        userId: profile.userId,
                        customUserId: profile.customUserId,
                        name: profile.basicDetails.name,
                        age: profile.basicDetails.age,
                        gender: profile.basicDetails.gender,
                        profilePicture: profile.basicDetails.profilePicture,
                        shortlisted: shortlistedIds.includes(profile.userId),
                        customUserId: profile.customUserId || 'N/A',
                    };
                    return acc;
                }, {});
                const personalResponse = await axios.get('https://back.varankal.com/user/all-personal-details', { withCredentials: true });
                const personalData = personalResponse.data;

                const mergedData = personalData.map(profile => ({
                    ...registerData[profile.userId],
                    occupation: profile.occupation,
                    religion: profile.religion,
                    caste: profile.caste,
                    income: profile.userIncome,
                    location: profile.location,
                    height: profile.height,
                    motherTongue: profile.motherTongue,
                }));

                // ✅ Sort shortlisted profiles to top
                mergedData.sort((a, b) => {
                    if (a.shortlisted === b.shortlisted) return 0;
                    return a.shortlisted ? -1 : 1;
                });

                setProfiles(mergedData); // ✅ Updated profile list
            } catch (error) {
                console.error('Error fetching user or profiles:', error);
            }
        };

        fetchData();
    }, []);

    const filteredProfiles = profiles.filter(applyFilters);


    useEffect(() => {
        const socket = io('https://back.varankal.com', {
            transports: ['websocket'],
            autoConnect: false, // don't connect automatically
            withCredentials: true
        });
        if (!currentUser || !currentUser.userId) return;

        socket.io.opts.query = { userId: currentUser.userId };
        socket.connect();

        // 🔄 Handle user status updates (online/offline)
        const handleStatusUpdate = (data) => {
            setUserStatus(prev => ({
                ...prev,
                [data.userId]: {
                    isOnline: data.isOnline,
                    lastSeen: data.isOnline ? null : data.lastSeen
                }
            }));
        };

        socket.on('update-user-status', handleStatusUpdate);

        const interval = setInterval(() => {
            socket.emit('heartbeat', { userId: currentUser.userId });
        }, 60000);

        return () => {
            socket.off('update-user-status', handleStatusUpdate);
            socket.disconnect();
            clearInterval(interval);
        };
    }, [currentUser]);


    const formatLastSeen = (lastSeen) => {
        if (!lastSeen) return 'Last seen unavailable';

        const seenDate = new Date(lastSeen);
        const now = new Date();

        const diffInSeconds = Math.floor((now - seenDate) / 1000);

        // 👇 If last seen was within the last 10 seconds, treat as online
        if (diffInSeconds <= 60) {
            return 'Online now';
        }

        if (isToday(seenDate)) {
            return `Today at ${format(seenDate, 'hh:mm a')}`;
        } else if (isYesterday(seenDate)) {
            return `Yesterday at ${format(seenDate, 'hh:mm a')}`;
        } else {
            const daysAgo = differenceInDays(now, seenDate);
            return `${daysAgo} day${daysAgo > 1 ? 's' : ''} ago`;
        }
    };



    useEffect(() => {
        const fetchAllLastSeen = async () => {
            const updatedStatus = {};

            await Promise.all(filteredProfiles.map(async (profile) => {
                if (!profile.userId) return;

                try {
                    const res = await axios.get(`https://back.varankal.com/auth/last-seen/${profile.userId}`, {
                        withCredentials: true
                    });

                    updatedStatus[profile.userId] = {
                        isOnline: false,
                        lastSeen: res.data.lastSeen || null
                    };
                } catch (err) {
                    updatedStatus[profile.userId] = {
                        isOnline: false,
                        lastSeen: null
                    };
                }
            }));

            setUserStatus(updatedStatus);
        };

        if (filteredProfiles.length > 0) {
            fetchAllLastSeen();
        }
    }, [filteredProfiles]);


    // const handleProfileClick = async (userId) => {
    //   try {
    //     const response = await axios.get(`https://back.varankal.com/user/view-profile/${userId}`, {
    //       withCredentials: true,
    //     });

    //     if (response.data.profile) {
    //       navigate(`/userpage/${userId}`);
    //     }
    //   } catch (error) {
    //     if (error.response && error.response.status === 403) {
    //       const msg = error.response.data.error;
    //       if (msg === "No active plan found") {
    //         setShowModal(true);
    //       } else {
    //         alert(msg || "Upgrade your plan to view more profiles.");
    //       }
    //     } else {
    //       showAlert("An error occurred while accessing the profile.");
    //     }
    //   }
    // };

    const handleSubscribe = () => {
        setShowModal(false);
        navigate("/subscription");
    };

    const handleProfileClick = (userId) => {
        window.scrollTo(0, 0); // ✅ Scroll to top
        navigate(`/userpage/${userId}`);
        console.log('handleprofile', userId);
    };



    const handleChatClick = async (profile) => {
        // if (profile.requestStatus !== 'Accepted') {
        //   showAlert("Chat is unavailable until the request is accepted.");
        //   return;
        // }

        try {
            const response = await axios.get(`https://back.varankal.com/user/view-profile/${profile.userId}`, {
                withCredentials: true,
            });

            if (response.data.profile) {
                // ✅ Trigger chat if user has access
                handleMessage(profile);
            }
        } catch (error) {
            if (error.response && error.response.status === 403) {
                const msg = error.response.data.error;
                if (msg === "No active plan found") {
                    setShowModal(true); // ✅ Show modal if no plan
                } else {
                    alert(msg || "Upgrade your plan to chat.");
                }
            } else {
                showAlert("An error occurred while trying to open chat.");
            }
        }
    };


    const handleClear = (field) => {
        setFilterCriteria((prev) => ({
            ...prev,
            [field]: "",
        }));
    };

    const handleRequest = async (profile) => {
        try {

            // if (profile.requestStatus === 'Pending' || profile.requestStatus === 'Accepted') {
            //   console.log('Request already sent or accepted');
            //   return;
            // }
            const payload = {
                senderId: currentUser.userId,
                receiverId: profile.userId,
                senderName: currentUser.name,
            };

            // Send request
            await axios.post('https://back.varankal.com/user/requests', payload, { withCredentials: true });
            showAlert('Request sent successfully!');
            // Refresh request status
            await updateRequestStatus(profile.userId);
        } catch (error) {
            console.error('Error sending request:', error.response ? error.response.data : error.message);
        }
    };

    const updateRequestStatus = async (receiverId) => {
        try {
            const statusResponse = await axios.get(
                `https://back.varankal.com/user/request-status/${currentUser.userId}/${receiverId}`,
                { withCredentials: true }
            );

            setProfiles(prevProfiles =>
                prevProfiles.map(p =>
                    p.userId === receiverId ? { ...p, requestStatus: statusResponse.data.status } : p
                )
            );

        } catch (error) {
            console.error('Error fetching request status:', error.response ? error.response.data : error.message);
        }

    };

    useEffect(() => {
        const fetchAllStatuses = async () => {
            const updatedProfiles = await Promise.all(profiles.map(async (profile) => {
                try {
                    const res = await axios.get(
                        `https://back.varankal.com/user/request-status/${currentUser.userId}/${profile.userId}`,
                        { withCredentials: true }
                    );
                    return { ...profile, requestStatus: res.data.status };
                } catch {
                    return profile; // Return profile as is if there's an error
                }
            }));

            setProfiles(updatedProfiles);
        };

        // Run fetchAllStatuses only if profiles are available and statuses haven't been fetched yet
        if (profiles.length > 0 && !statusFetched) {
            fetchAllStatuses();
            setStatusFetched(true); // Set the flag to true after the statuses are fetched
        }
    }, [profiles, currentUser.userId, statusFetched, setProfiles]);


    const removeAcceptedRequest = async (receiverId) => {
        const confirmDelete = window.confirm("Are you sure you want to remove this accepted request?");
        if (!confirmDelete) return;
        try {
            const response = await axios.delete(
                `https://back.varankal.com/user/remove-request/${currentUser.userId}/${receiverId}`,
                { withCredentials: true }
            );
            console.log(response.data);
            // Refresh requestStatus after removing
            updateRequestStatus(receiverId);
        } catch (error) {
            console.error('Error removing accepted request:', error);
        }
    };



    const handleMessage = (profile) => {
        if (!selectedProfiles.find(p => p.userId === profile.userId)) {
            setSelectedProfiles([...selectedProfiles, profile]);
        }
    };

    const handleCloseChatroom = (userId) => {
        setSelectedProfiles(selectedProfiles.filter(profile => profile.userId !== userId));
    };

    const handleShortlistToggle = (userId, isShortlisted) => {
        if (isShortlisted) {
            unshortlistUser(userId);
        } else {
            shortlistUser(userId);
        }
    };

    const shortlistUser = async (userId) => {
        try {
            const response = await axios.post(
                `https://back.varankal.com/auth/shortlist/${userId}`,
                { currentUserId: currentUser.userId }, // Ensure you're passing the correct data
                { withCredentials: true }
            );
            console.log('Shortlisted:', response);
            setProfiles(prev =>
                prev.map(p =>
                    p.userId === userId ? { ...p, shortlisted: true } : p
                )
            );
        } catch (error) {
            console.error('Error shortlisting user:', error.response ? error.response.data : error.message);
        }
    };

    const unshortlistUser = async (userId) => {

        try {
            const response = await axios.post(
                `https://back.varankal.com/auth/unshortlist/${userId}`,
                { currentUserId: currentUser.userId },
                { withCredentials: true }
            );
            console.log('Unshortlisted:', response);

            // ✅ Update UI
            setProfiles(prev =>
                prev.map(p =>
                    p.userId === userId ? { ...p, shortlisted: false } : p
                )
            );

        } catch (error) {
            console.error('Error unshortlisting user:', error);
        }
    };


    const fetchShortlistedUsers = async () => {
        try {
            const response = await axios.get('https://back.varankal.com/auth/shortlisted', { withCredentials: true });
            console.log('Shortlisted Users:', response.data);
            setShortlistedUsers(response.data);
        } catch (error) {
            console.error('Error fetching shortlisted users:', error.response ? error.response.data : error.message);
            setError('Error fetching shortlisted users');
        }
    };

    const removeShortlistUser = async (userId) => {
        const confirmed = window.confirm("Are you sure you want to remove this user from your shortlist?");
        if (!confirmed) return; // If user clicks Cancel, do nothing
        try {
            const response = await axios.delete(
                `https://back.varankal.com/auth/shortlist/remove/${userId}`,
                {
                    data: { currentUserId: currentUser.userId }, // Pass body in `data` for DELETE
                    withCredentials: true,
                }
            );
            console.log("Removed from shortlist:", response.data);

            // Update local state to reflect removal
            setProfiles((prev) =>
                prev.map((p) =>
                    p.userId === userId ? { ...p, shortlisted: false } : p
                )
            );
        } catch (error) {
            console.error(
                "Error removing user from shortlist:",
                error.response ? error.response.data : error.message
            );
        }
    };


    // Call fetchShortlistedUsers when component mounts
    useEffect(() => {
        fetchShortlistedUsers(); // Fetch shortlisted users
    }, [currentUser.userId]);



    useEffect(() => {
        const fetchMatchScores = async () => {
            try {
                const response = await axios.get('https://back.varankal.com/app/userreports/match-score', {
                    withCredentials: true
                });
                console.log("Match Scores Response:", response.data); // Debugging log
                setMatchScores(response.data.topMatches || []);
            } catch (error) {
                console.error('Error fetching match scores:', error);
            }
        };

        fetchMatchScores();
    }, []);

    const getMatchScore = (userId) => {
        if (!userId) {
            console.error("No userId provided for profile:", userId); // Log if userId is missing
            return null;
        }
        const match = matchScores.find(m => m.userId && m.userId.toString() === userId.toString());
        console.log("Match for userId", userId, ":", match); // Log the match if found

        return match ? match.matchScore : null;
    };



    return (
        <>
            <MainNavbar />
            <div className='layout-container'>
                <Helmet>
                    <title>
                        Tamil Matrimony Services | Varankal.com | Hindu, Christian, Muslim, NRI Matches
                    </title>
                    <meta
                        name="description"
                        content="Explore Tamil Matrimony Services at Varankal.com – find perfect Tamil Hindu, Christian, Muslim, Elite, and NRI brides and grooms. Verified profiles with 100% privacy."
                    />
                    <meta
                        name="keywords"
                        content="Tamil Hindu Matrimony, Tamil Christian Matrimony, Tamil Muslim Matrimony, NRI Tamil Matrimony, Elite Matrimony, Divorcee Matrimony, Tamil Marriage Services, Online Tamil Matrimony"
                    />
                </Helmet>
                <>
                    {showProfileModal && (
                        <div
                            className="modal-backdropR"
                            role="dialog"
                            aria-modal="true"
                            aria-labelledby="modalTitleR"
                        >
                            <div className="modal-boxR animateFadeInR">

                                <button
                                    className="modal-close-btnR"
                                    onClick={() => setShowProfileModal(false)}
                                    aria-label="Close modal"
                                >
                                    <IoMdClose />
                                </button>

                                <GiPartyPopper className="modal-iconR" />

                                {/* 🔥 Dynamic Title */}
                                <h2 id="modalTitleR" className="modal-titleR">
                                    {stepTitle}
                                </h2>

                                <p className="modal-descriptionR">
                                    To find your perfect match, please complete your profile.
                                    This helps us tailor suggestions just for you.
                                </p>

                                <p className="modal-highlight-noteR">
                                    🔒 <strong>Note:</strong> Once you complete the <strong>Registration</strong>,
                                    only then you will be able to <strong>view your profile</strong>.
                                </p>

                                <div className="modal-buttonsR">
                                    <button
                                        className="modal-buttonR modal-create-btnR"
                                        onClick={() => {
                                            if (step === "0") navigate("/register");
                                            else if (step === "1") navigate("/create");
                                            else if (step === "2") navigate("/preference");
                                            else navigate("/dashboard");
                                        }}
                                    >
                                        {buttonText}
                                    </button>
                                </div>

                            </div>
                        </div>
                    )}
                </>

                <div className="header-section8843">
                    <h1>
                        {selectedReligions.length > 0
                            ? `Tamil ${selectedReligions.join(", ")} Matrimony`
                            : "Find Your Life Partner"}
                    </h1>

                    <p>
                        {lastSelectedReligion
                            ? religionContent[lastSelectedReligion]
                            : "Find profiles that match your preferences, lifestyle, interests and compatibility for lasting connections."}
                    </p>
                </div>




                <div className="search-bar-wrapper884L">
                    <div className="search-bar884L">
                        <HiOutlineSearch className="search-icon884L" />
                        <input
                            type="text"
                            placeholder="Search by Name or User ID"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="search-input884L"
                        />
                    </div>


                </div>

                <aside className="sidebar-filterL">
                    <h3 className="sidebar-titleL">Filter Profiles</h3>

                    <div className="age-rangeL">
                        <label>Age Range: 21 - {filterCriteria.ageRange[1]}</label>

                        {/* Hidden or fixed starting age */}
                        <input
                            type="hidden"
                            value={21}
                        />

                        {/* Only ending age is adjustable */}
                        <input
                            type="range"
                            min="21"
                            max="70"
                            value={filterCriteria.ageRange[1]}
                            onChange={(e) =>
                                setFilterCriteria(prev => ({
                                    ...prev,
                                    ageRange: [21, parseInt(e.target.value)]
                                }))
                            }
                        />
                    </div>

                    <div className="filter-groupL">
                        <label className="checkbox-optionL">
                            <input
                                type="checkbox"
                                checked={filterCriteria.shortlistedOnly}
                                onChange={(e) =>
                                    setFilterCriteria(prev => ({
                                        ...prev,
                                        shortlistedOnly: e.target.checked
                                    }))
                                }
                            />
                            <span>Shortlisted Only</span>
                        </label>
                    </div>

                    {filterGroups.map(({ name, label, options }) => {
                        const isExpanded = expandedFilters[name];
                        const visibleOptions = isExpanded ? options : options.slice(0, 5);

                        return (
                            <div key={name} className="filter-groupL">
                                <h4 className="filter-group-titleL">{label}</h4>
                                <div className="filter-optionsL">
                                    {visibleOptions.map((opt, idx) => (
                                        <label key={idx} className="checkbox-optionL">
                                            <input
                                                type="checkbox"
                                                value={opt.value}
                                                checked={filterCriteria[name].includes(opt.value)}
                                                onChange={(e) => {
                                                    const isChecked = e.target.checked;

                                                    setFilterCriteria(prev => {
                                                        const updated = isChecked
                                                            ? [...prev[name], opt.value]
                                                            : prev[name].filter(v => v !== opt.value);
                                                        return { ...prev, [name]: updated };
                                                    });

                                                    // 🟣 Religion-specific behavior
                                                    if (name === "religion") {
                                                        if (isChecked) {
                                                            setSelectedReligions(prev => [...prev, opt.value]);
                                                            setLastSelectedReligion(opt.value); // store the most recent one
                                                        } else {
                                                            setSelectedReligions(prev => prev.filter(r => r !== opt.value));
                                                            setLastSelectedReligion(""); // clear if none selected
                                                        }
                                                        window.scrollTo({ top: 0, behavior: "smooth" }); // scroll to top
                                                    }
                                                }}




                                            />
                                            <span>{opt.label}</span>
                                        </label>
                                    ))}

                                    {options.length > 5 && (
                                        <button
                                            className="view-more-btnL2"
                                            onClick={() =>
                                                setExpandedFilters(prev => ({
                                                    ...prev,
                                                    [name]: !prev[name]
                                                }))
                                            }
                                        >
                                            {isExpanded ? 'View Less' : 'View More'}
                                        </button>
                                    )}
                                </div>
                            </div>
                        );
                    })}

                    <div className="button-groupL">
                        <button className="apply-btnL" onClick={handleFilterChange}>Apply Filters</button>
                        <button className="reset-btnL" onClick={handleReset}>
                            <FontAwesomeIcon icon={faTimes} /> Clear All
                        </button>
                    </div>
                </aside>

                <div className="mainprofile1">


                    <div className="filterjjjL">
                        <div className="filter-content884L">
                        </div>
                    </div>


                    <div className="profile-grid8890">

                        {
                            filteredProfiles.length > 0 ? (
                                filteredProfiles.map(profile => (

                                    <div key={profile.userId} className="profile-card-clean" onClick={() => handleProfileClick(profile.userId)}>
                                        <div className="profile-left">
                                            <img
                                                src={`data:image/jpeg;base64,${profile.profilePicture}`}
                                                alt="Profile"
                                                className="profile-img"
                                            />
                                            {(() => {
                                                const userPlan = planInfo.find(planUser => planUser.userId === profile.userId)?.plan;

                                                if (!userPlan) return null;

                                                let PlanIcon;

                                                switch (userPlan) {
                                                    case 'Basic':
                                                        PlanIcon = <GiCheckedShield color="green" size={20} title="Basic Plan" />;
                                                        break;
                                                    case 'Silver':
                                                        PlanIcon = <GiMetalBar color="gray" size={20} title="Silver Plan" />;
                                                        break;
                                                    case 'Gold':
                                                        PlanIcon = <GiGoldBar color="gold" size={20} title="Gold Plan" />;
                                                        break;
                                                    case 'Platinum':
                                                        PlanIcon = <GiTrophyCup color="blue" size={20} title="Platinum Plan" />;
                                                        break;
                                                    case 'Diamond':
                                                        PlanIcon = <GiCutDiamond color="deepskyblue" size={20} title="Diamond Plan" />;
                                                        break;
                                                    default:
                                                        return null;
                                                }

                                                return (
                                                    <div className="user-plan888">
                                                        {PlanIcon}
                                                    </div>
                                                );
                                            })()}
                                        </div>

                                        <div className="profile-right">
                                            <div className="profile-header">
                                                <h3 className="profile-name" style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                                    {profile.name}

                                                    <br></br>
                                                    <span style={{ fontSize: '14px', color: 'gray', textTransform: 'uppercase', }}>
                                                        ({profile.customUserId})
                                                    </span>

                                                    {/* ({profile.customUserId}) */}
                                                </h3>
                                            </div>




                                            <div className="profile-status">
                                                {userStatus[profile.userId]?.isOnline || formatLastSeen(userStatus[profile.userId]?.lastSeen) === 'Online now' ? (
                                                    <span className="status status-online">
                                                        <AiOutlineMessage className="chat-icon" size={16} />
                                                        Online now
                                                    </span>
                                                ) : userStatus[profile.userId]?.lastSeen ? (
                                                    <span className="status status-lastseen">
                                                        <AiOutlineMessage className="chat-icon" size={16} />
                                                        {formatLastSeen(userStatus[profile.userId]?.lastSeen)}
                                                    </span>
                                                ) : (
                                                    <span className="status status-unavailable">
                                                        <AiOutlineMessage className="chat-icon" size={16} />
                                                        Checking status...
                                                    </span>
                                                )}

                                                <span
                                                    className="status-you-her"
                                                    onClick={() => {
                                                        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                                                    }}
                                                >
                                                    {currentUser?.gender?.toLowerCase() === 'female' ? 'You & Him' : 'You & Her'}
                                                </span>

                                            </div>

                                            <hr className='hrlinej'></hr>
                                            <div className="profile-details-grid">
                                                <div><strong>{profile.age} yrs, {profile.height} cm</strong></div>
                                                <div><strong>{profile.maritalStatus || "Never Married"}</strong></div>
                                                <div>{profile.religion}</div>
                                                <div>{profile.occupation}</div>
                                                <div>{profile.caste}</div>
                                                <div>{profile.location?.district}</div>

                                            </div>

                                            <p className="profile-bio">
                                                {profile.bio?.length > 100
                                                    ? `${profile.bio.slice(0, 90)}...`
                                                    : profile.bio}
                                                <span className="bio-more"> More</span>
                                            </p>

                                            <div className="profile-action">
                                                {profile.requestStatus === 'Pending' ? (
                                                    <button disabled className="connect-btn pending">Request Sent</button>
                                                ) : profile.requestStatus === 'Accepted' ? (
                                                    <button
                                                        className="connect-btn accepted"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleChatClick(profile); // ✅ open chat only if valid
                                                        }}
                                                    >
                                                        Chat
                                                    </button>

                                                ) : profile.requestStatus === 'Rejected' ? (
                                                    <button className="connect-btn" onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleRequest(profile); // Resend the request
                                                    }}>
                                                        Connect Now
                                                    </button>
                                                ) : (
                                                    <button className="connect-btn" onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleRequest(profile); // Initial request
                                                    }}>
                                                        Connect Now
                                                    </button>
                                                )}

                                                <div className="shortlist-tooltip-container7878">
                                                    {profile.shortlisted ? (
                                                        <FiUserCheck
                                                            size={30}
                                                            color="crimson"
                                                            className="shortlist-icon"
                                                            title="Shortlist"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                unshortlistUser(profile.userId); // ✅ use confirmation logic here
                                                                showAlert('Removed from shortlist');
                                                            }}
                                                        />
                                                    ) : (
                                                        <FiUser
                                                            size={30}
                                                            color="gray"
                                                            className="shortlist-icon"
                                                            title="Unshortlist"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleShortlistToggle(profile.userId, profile.shortlisted);
                                                                showAlert('Added to your shortlisted profiles');
                                                            }}
                                                        />
                                                    )}

                                                    <span className="tooltip-text-shortlist">
                                                        {profile.shortlisted ? "Shortlisted" : "Shortlist"}
                                                    </span>
                                                </div>


                                            </div>


                                        </div>

                                    </div>


                                ))


                            ) : (
                                <p className='texttt88'>Waiting for finding your partner...</p>
                            )
                        }

                    </div>


                </div>


                {
                    selectedProfiles.length > 0 && selectedProfiles.map(profile => (
                        <Chatroom key={profile.userId} currentUser={currentUser} selectedProfile={profile}
                            onClose={() => handleCloseChatroom(profile.userId)} />

                    ))
                }
            </div>


        </>
    );
};

export default HomeList;
